import React from 'react'
import Link from 'next/link'
import classnames from 'classnames'

import { IFeedData } from 'lib/fetch-feed'
import Button from 'Components/button'
import { sendTeaCommEvent } from 'lib/tea-analyze'

interface IProps {
  hideLine?: boolean
  curIndex?: number
  leftContent: string
  rightContent?: string[]
  moreContent?: string
  moreLink?: string
  children?: React.ReactChild
  setCurIndex?: (e: number) => void
  setList?: (e: IFeedData[]) => void
  onClick?: (index: number) => void
  handleMoreClick?: () => void
  id?: string
}

export default function Tab({
  curIndex = -1,
  setCurIndex,
  leftContent,
  rightContent,
  setList,
  hideLine,
  children,
  onClick,
  moreContent,
  moreLink,
  handleMoreClick,
  id,
}: IProps) {
  return (
    <section
      id={id || ''}
      className={classnames('clearfix', {
        'hide-line': hideLine,
      })}
    >
      <h2 className="fl" data-module={leftContent}>
        {leftContent}
      </h2>
      {children}
      <div className="conditions">
        {rightContent &&
          rightContent.map((item: string, index: number) => (
            // <span
            //   key={item}
            //   className={`sort ${classnames({
            //     active: index === curIndex,
            //   })}`}
            //   onClick={e => {
            //     e.stopPropagation()
            //     setCurIndex && setCurIndex(index)
            //     setList && setList([])
            //     onClick && onClick(index)
            //   }}
            // >
            //   {item}
            // </span>

            <Button
              key={item}
              className={`sort button button-price  ${classnames({
                active: index === curIndex,
              })}`}
              onClick={e => {
                e.stopPropagation()
                setCurIndex && setCurIndex(index)
                setList && setList([])
                onClick && onClick(index)
              }}
              type="default"
            >
              {item}
            </Button>
          ))}
      </div>
      <div className="fr">
        {moreLink ? (
          <Link href={moreLink}>
            <a className="more" onClick={handleMoreClick}>
              {moreContent || '查看更多'}
            </a>
          </Link>
        ) : null}
      </div>
      <style jsx>
        {`
          section {
            padding-left: 16px;
            padding-right: 18px;
            line-height: 53px;
          }
          .hide-line {
            box-shadow: 0 1px 0 0 #ededed;
          }
          p {
            margin-left: 12px;
            font-size: 24px;
            font-weight: 500;
          }
          .conditions {
            float: right;
          }
          .more {
            position: relative;
            padding-right: 12px;
            font-size: 16px;
            color: #1a1a1a;
          }
          .more::after {
            content: '';
            position: absolute;
            top: 3px;
            right: 0;
            display: inline-block;
            width: 8px;
            height: 16px;
            background-image: url('https://sf3-ttcdn-tos.pstatp.com/obj/motor-img/71f5b53ca5498e6dada190a073a8d1d0');
            background-size: 100% 100%;
          }
          span {
            line-height: 22px;
            padding: 0 12px;
            border-right: 1px solid #e6e6e6;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.2s ease;
          }
          span:hover {
            color: #ff9100;
          }
          span:last-child {
            border-right: 0;
          }

          h2 {
            font-size: 18px;
            font-weight: 500;
          }
          .conditions :global(.button) {
            min-width: 48px;
            box-sizing: border-box;
            margin-left: 8px;
            padding: 0 12px;
            height: 24px;
            margin-top: 16px;
            line-height: 24px;
            background: #f7f8fc;
            border-radius: 2px;
            border: 0.5px solid #f7f8fc;
            font-size: 12px;
            color: #1f2129;
            letter-spacing: 0;
            font-weight: 400;
          }
          .conditions :global(.button-param) {
            margin-left: 8px;
            border: solid 1px #cccccc;
          }
          .conditions :global(.active) {
            box-sizing: border-box;
            background: rgba(255, 204, 50, 0.12);
            border: 0.5px solid #ffcd32;
            border-radius: 2px;
          }
        `}
      </style>
    </section>
  )
}
